import { features } from '@/mocks/content';

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-shield-star-line"></i>
            平台优势
          </div>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            为什么选择九游娱乐
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto text-sm md:text-base">
            四大核心优势，为您打造极致的在线娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8 text-center hover:border-primary-200 transition-all duration-300 group"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100/70 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2.5">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}